import { Link } from 'react-router-dom';
import { Spinner } from '@klaro7/ui';

import { useRecentUserActivity } from '../hooks/useUserActivity';
import { ActivityEntryRow } from './ActivityEntryRow';

/** Card compatta con gli ultimi 5 eventi + link alla timeline completa (super-admin). */
export function UserActivityRecentCard({ userId }: { userId: string }) {
  const { data, isLoading, isError } = useRecentUserActivity(userId, 5);
  const items = data?.items ?? [];

  return (
    <div className="rounded-xl border border-neutral-200 bg-white">
      <div className="flex items-center justify-between gap-3 border-b border-neutral-100 px-5 py-3.5">
        <div>
          <h3 className="text-sm font-semibold text-neutral-700">Ultime attività</h3>
          <p className="text-xs text-neutral-500">Accessi, SMS, email, chiamate, bonus ed errori</p>
        </div>
        <Link
          to={`/dashboard/admin/users/${userId}/timeline`}
          className="shrink-0 text-sm font-medium text-brand-teal hover:underline"
        >
          Storico completo
        </Link>
      </div>
      {isLoading ? (
        <div className="flex justify-center py-8">
          <Spinner />
        </div>
      ) : isError ? (
        <p className="px-5 py-6 text-sm text-red-600">Impossibile caricare le attività.</p>
      ) : items.length === 0 ? (
        <p className="px-5 py-6 text-sm text-neutral-400">Nessuna attività registrata.</p>
      ) : (
        <ul className="divide-y divide-neutral-100">
          {items.map((e) => (
            <ActivityEntryRow key={e._id} entry={e} compact />
          ))}
        </ul>
      )}
    </div>
  );
}
